import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReasonsComponent } from './reasons.component';
import { EditReasonComponent } from './components/edit-reason/edit-reason.component';

const routes: Routes = [
  { path: '', component: ReasonsComponent },
  { path: 'editar/:id', title: 'Editar Motivo de Atendimento', component: EditReasonComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReasonRoutingModule {}
